<div class="container-fluid">
  <app-pagetitle title="Users" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

  <div class="main-card-container">
    <div class="card">
      <div class="card-body">
        <!-- Header Section -->
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h4 class="card-title mb-0">Users</h4>
          
          <div class="d-flex align-items-center gap-2">
            <div class="dropdown" ngbDropdown>
              <button class="btn btn-light" ngbDropdownToggle>
                <i class="mdi mdi-dots-vertical"></i>
              </button>
              <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                <a href="javascript:void(0);" class="dropdown-item">
                  <i class="mdi mdi-download me-2"></i>Export Users
                </a>
              </div>
            </div>
            <button class="btn btn-light" (click)="refresh()" ngbTooltip="Refresh">
              <i class="mdi mdi-refresh"></i>
            </button>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="mb-4">
          <button type="button" class="btn btn-primary w-100 w-sm-auto" (click)="onAddNew(addEditModal)">
            <i class="mdi mdi-plus-circle me-1"></i>Add New User
          </button>
        </div>

        <!-- Search Box -->
        <div class="search-box mb-4">
          <div class="position-relative">
            <input type="text" 
                   class="form-control" 
                   placeholder="Search users..."
                   [(ngModel)]="term">
            <i class="mdi mdi-magnify search-icon"></i>
          </div>
        </div>

        <!-- Table Section -->
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th class="sticky-col">Name</th>
                <th>Username</th>
                <th>Email</th>
                <th>Type</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of users">
                <td class="sticky-col">
                  <div class="d-flex flex-column">
                    <span>{{item.firstName}} {{item.lastName}}</span>
                  </div>
                </td>
                <td>{{item.username}}</td>
                <td>{{item.primaryEmail}}</td>
                <td>
                  <span
                    class="badge"
                    [ngClass]="{
                      'bg-primary': item.userType === 'INTERNAL',
                      'bg-info': item.userType === 'TECH',
                      'bg-success': item.userType === 'COLLECTOR'
                    }"
                    >
                    {{item.userType}}
                  </span>

                </td>
                <td>
                  <div class="form-check form-switch">
                    <input type="checkbox" 
                           class="form-check-input" 
                           [checked]="item.enabled"
                           (change)="onCheckBoxChanged($event, item)"
                           id="enabled-{{item.id}}">
                  </div>
                </td>
                <td>
                  <div class="d-flex gap-2">
                    <button class="btn btn-sm btn-light" (click)="onEdit(item, addEditModal)" ngbTooltip="Edit">
                      <i class="mdi mdi-pencil"></i>
                    </button>
                    <button class="btn btn-sm btn-light" (click)="onResetPassword(item)" ngbTooltip="Reset Password">
                      <i class="mdi mdi-lock-reset"></i>
                    </button>
                    <button class="btn btn-sm btn-light text-danger" (click)="onDelete(item)" ngbTooltip="Delete">
                      <i class="mdi mdi-trash-can"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <!-- Empty State -->
          <div *ngIf="users?.length === 0" class="text-center py-5">
            <p class="text-muted mb-0">No users found</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Add/Edit Modal -->
  <ng-template #addEditModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">{{addEditMode}} User</h4>
      <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
    </div>
    
    <div class="modal-body">
      <form [formGroup]="userAddEditFormGroup">
        <!-- Username Field -->
        <div class="form-group mb-3" *ngIf="addEditMode=='Add'">
          <label class="form-label">Username</label>
          <input type="text" 
                 class="form-control" 
                 formControlName="username" 
                 placeholder="Enter username">
          <div class="invalid-feedback d-block" *ngIf="username.invalid && (username.touched || username.dirty)">
            Username must be at least 4 characters long
          </div>
        </div>

        <!-- Name Fields -->
        <div class="row g-3 mb-3">
          <div class="col-12 col-md-6">
            <label class="form-label">First Name</label>
            <input type="text" 
                   class="form-control" 
                   formControlName="firstName" 
                   placeholder="Enter first name">
            <div class="invalid-feedback d-block" *ngIf="firstName.invalid && (firstName.touched || firstName.dirty)">
              First name is required
            </div>
          </div>
          
          <div class="col-12 col-md-6">
            <label class="form-label">Last Name</label>
            <input type="text" 
                   class="form-control" 
                   formControlName="lastName" 
                   placeholder="Enter last name">
            <div class="invalid-feedback d-block" *ngIf="lastName.invalid && (lastName.touched || lastName.dirty)">
              Last name is required
            </div>
          </div>
        </div>

        <!-- Email Field -->
        <div class="form-group mb-3">
          <label class="form-label">Email Address</label>
          <input type="email" 
                 class="form-control" 
                 formControlName="primaryEmail" 
                 placeholder="Enter email address">
          <div class="invalid-feedback d-block" *ngIf="primaryEmail.invalid && (primaryEmail.touched || primaryEmail.dirty)">
            Email address is required
          </div>
        </div>

        <!-- User Type Field -->
        <div class="form-group">
          <label class="form-label">User Type</label>
          <select class="form-select" formControlName="userType">
            <option *ngFor="let type of userTypes" [value]="type.key">
              {{type.value}}
            </option>
          </select>
        </div>
      </form>
    </div>
    
    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="modal.dismiss()">Cancel</button>
      <button type="button" 
              class="btn btn-primary" 
              [disabled]="userAddEditFormGroup.invalid"
              (click)="modal.close('Save click')">
        Save Changes
      </button>
    </div>
  </ng-template>
</div>